const labServiceSections = document.querySelectorAll( "section.lab-services" );

labServiceSections.forEach( ( section ) => {
  let current = 0;
  const sliderGroup = section.querySelector( ".slider-group" ),
    slider = section.querySelector( ".lab-services-slider" ),
    slides = section.querySelectorAll( ".lab-services-slider .group" ),
    prev = section.querySelectorAll( ".slider-controls .prev" ),
    next = section.querySelectorAll( ".slider-controls .next" );

  let slideWidth = 449; // initial slide width for larger screens
  let maxSlides = 1; // Default max slides on mobile view

  function updateSlideWidth () {
    const containerWidth = sliderGroup.offsetWidth; // Get the width of the slider container
    // Adjust the slide width based on the container width
    slideWidth = containerWidth < 500 ? containerWidth : 449; // Set a smaller width for mobile if needed

    maxSlides = Math.floor( containerWidth / slideWidth ); // Calculate max slides based on container width and slide width
    handleButtonEnabling(); // Update the buttons after resize or initial calculation
  }

  // enable/disable buttons
  function handleButtonEnabling () {
    prev.forEach( ( button ) => {
      button.disabled = current === 0;
    } );
    next.forEach( ( button ) => {
      button.disabled = current >= slides.length - maxSlides || maxSlides >= slides.length;
    } );
  }

  // Initialize button states and slide width on page load
  updateSlideWidth();
  handleButtonEnabling();

  // previous button
  prev.forEach( ( button ) => {
    button.addEventListener( "click", function () {
      if ( current <= 0 ) return;

      current--;
      sliderGroup.style.transform = `translateX(${ current * slideWidth * -1 }px)`;
      handleButtonEnabling();
      slider.classList.add( "nothing" ); // replaced 'sliding'
      setTimeout( () => {
        slider.classList.remove( "nothing" ); // replaced 'sliding'
      }, 500 );
    } );
  } );

  // next button
  next.forEach( ( button ) => {
    button.addEventListener( "click", function () {
      if ( current >= slides.length - maxSlides ) return;

      current++;
      sliderGroup.style.transform = `translateX(${ current * slideWidth * -1 }px)`;
      handleButtonEnabling();
      slider.classList.add( "nothing" ); // replaced 'sliding'
      setTimeout( () => {
        slider.classList.remove( "nothing" ); // replaced 'sliding'
      }, 500 );
    } );
  } );

  // Resize event listener to adjust for different screen sizes
  window.addEventListener( "resize", function () {
    current = 0;
    updateSlideWidth();
    sliderGroup.style.transform = `translateX(0px)`;
  } );
} );
